import { NetworkGatewayType } from 'decentraland-ui/dist/components/BuyManaWithFiatModal/Network';
export var FiatGateway;
(function (FiatGateway) {
    FiatGateway["WERT"] = "wert";
})(FiatGateway || (FiatGateway = {}));
export var PurchaseStatus;
(function (PurchaseStatus) {
    PurchaseStatus["PENDING"] = "pending";
    PurchaseStatus["FAILED"] = "failed";
    PurchaseStatus["CANCELLED"] = "cancelled";
    PurchaseStatus["REFUNDED"] = "refunded";
    PurchaseStatus["COMPLETE"] = "complete";
})(PurchaseStatus || (PurchaseStatus = {}));
//# sourceMappingURL=types.js.map